import http from './http';

export function pcCardTemplateList({ address, cardType = '' } = {}) {
  return http.postJson('/pc/card/template/list', {
    address,
    cardType
  });
}

export function pcCardCreatePre({ address } = {}, config = {}) {
  return http.postJson('/pc/card/create/pre', { address }, config);
}

export function pcCardCreateV2({ address, templateId, invitationCode = '', scene = '', deviceToken = '', pcbId }) {
  return http.postJson('/pc/card/create/v2', {
    address,
    templateId,
    invitationCode,
    scene,
    deviceToken,
    pcbId
  });
}

export function cardMyList({ address, pageNum = 1, pageSize = 999, deviceToken = '', cardType } = {}, config = {}) {
  return http.postJson('/pc/card/my/list', {
    address,
    pageNum,
    pageSize,
    deviceToken,
    cardType
  }, config);
}

export function cardPrivateInfo({ address, cardId }) {
  return http.postJson('/pc/card/private/info', {
    address,
    cardId
  });
}

export function pcCardLogList({ address, pageNum = 1, pageSize = 10, cardId = '', lastDays = '' } = {}, config = {}) {
  return http.postJson('/pc/card/log/list', {
    address,
    pageNum,
    pageSize,
    cardId,
    lastDays
  }, config);
}

export function pcCardRightInfo({ address, cardId }) {
  return http.postJson('/pc/card/right/info', {
    address,
    cardId
  });
}

export const pcCardCancel = ({ cardId } = {}, config = {}) => {
  return http.postJson('/pc/card/cancel', { cardId }, config);
};

export const pcCardCancelList = (config = {}) => {
  return http.postJson('/pc/card/cancel/list', {}, config);
};

export const pcCardCancelDetail = ({ id } = {}, config = {}) => {
  return http.postJson('/pc/card/cancel/detail', { id }, config);
};

export function pcCardGetClientAccessToken({ address, cardId }) {
  return http.postJson('/pc/card/getClientAccessToken', {
    address,
    cardId
  });
}

export function pcCardChargeInfo({ address, cardId }) {
  return http.postJson('/pc/card/charge/info', {
    address,
    cardId
  });
}

export function pcCardWithdrawInfo({ address, cardId }) {
  return http.postJson('/pc/card/withdraw/info', {
    address,
    cardId
  });
}

export function pcCardCharge({ address, amount, cardId }) {
  return http.postJson('/pc/card/charge', {
    address,
    amount,
    cardId
  });
}

export function pcCardWithdraw({ address, amount, cardId }) {
  return http.postJson('/pc/card/withdraw', {
    address,
    amount,
    cardId
  });
}

export function pcCardUpdatePIN({ address, cardId, pin }) {
  return http.postJson('/pc/card/updatePIN', {
    address,
    cardId,
    pin
  });
}

export function pcCardPhysicalActiveSendV2({ address }) {
  return http.postJson('/pc/card/physical/active/send/v2', {
    address
  });
}

export function pcCardPhysicalActiveV2({ address, cardNum, activeCode, emailCode }) {
  return http.postJson('/pc/card/physical/active/v2', {
    address,
    cardNum,
    activeCode,
    emailCode
  });
}

export function activePhysicalCard(payload = {}) {
  return http.postJson('/pc/card/physical/active/v2', payload);
}

export function courseRedeem({ code } = {}) {
  return http.postJson('/course/redeem', {
    code
  });
}

export function physicalPay(payload) {
  return http.postJson('/pc/card/physical/pay', payload);
}

export function unActiveCardNum() {
  return http.postJson('/pc/card/physical/count', {});
}

export function getUserKyc({ address }) {
  return http.postJson('/pc/card/kyc/get', {
    address
  });
}

export function getDiditToken(payload) {
  return http.postJson('/didit/getToken', payload);
}

export function v1CommonCountryList({ address = '' } = {}) {
  return http.postJson('/v1/common/country/list', {
    address
  });
}

export function v1CommonProvinceList({ countryId }) {
  return http.postJson('/v1/common/province/list', {
    countryId
  });
}

export function v1CommonCityList({ countryId, provinceId }) {
  return http.postJson('/v1/common/city/list', {
    countryId,
    provinceId
  });
}

export function pcCardEmailSend({ address, email }) {
  return http.postJson('/pc/card/email/send', {
    address,
    email
  });
}

export function pcCardHolderCreate(payload) {
  return http.postJson('/pc/card/holder/create', payload);
}
